__turbopack_context__.v({
  "notificationStatusText": "NotificationSettings-module__s4NviG__notificationStatusText",
  "subtitle": "NotificationSettings-module__s4NviG__subtitle",
});
